import { ApiState } from '../../../common/constants/api-constants';

export enum OptInStatus {
  CLOSED = 'closed',
  OPEN = 'open',
}

export declare interface OptinOutData {
  productIsbn: string;
  productDescription: string;
  edition: number;
  formatCode: string;
  formatDescription: string;
  authors: Array<string>;
  lastUpdatedDate: string;
  expiryDate: string | undefined;
  isbn10: string;
  isbn13: string;
  coverImage: string;
  virtual: true;
  mhid: string;
  productSegment: string;
  productBrandingCode: string;
  copyrightYear: number;
  isUserOptedIn: boolean;
  optInStatus: string;
  userSectionOptInOutMetaData: OptInOutMetaData;
}

export declare interface OptInOutMetaData {
  dealId: string;
  sectionXid: string;
  isbn: string;
  expiryDate: string;
  sectionId: number;
  sectionUuid: string;
  organizationXid: string;
  instructorXid: string;
  action?: string;
  calledFrom?: string;
  platform: string;
}
export declare interface InclusiveAccessState extends ApiState {
  data: OptinOutData[];
}
